 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		71: 0,
 		69: 0,
 		70: 0,
 		80: 0,
 		124: 0,
 		125: 0,
 		132: 0,
 		133: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","6":"AddClosedAlertIDUseCase","7":"CreateDeviceUseCase","8":"CreateDomestikaFollowUseCase","9":"CreateJWTUserUseCase","10":"CreateUserLiveSessionUseCase","11":"CurrentUserUseCase","12":"CurrentWithoutRelationshipsUserUseCase","13":"DeleteDeviceUseCase","14":"DeleteFollowUseCase","15":"ENV_CONFIG1","16":"ENV_CONFIG4","17":"ENV_CONFIG5","18":"ENV_CONFIG6","19":"ENV_CONFIG7","20":"FinishUserLiveSessionUseCase","21":"GetAccessTokenUserUseCase","22":"GetAdvanceGDPRStatusUserUseCase","23":"GetAllBlogUseCase","24":"GetAreasCourseUseCase","25":"GetCartCourseUseCase","26":"GetCategoriesCourseUseCase","27":"GetCourseUseCase","28":"GetFinalProjectVideoByCourseIDCourseUseCase","29":"GetGDPRStatusUserUseCase","30":"GetListLiveFeedbackQuestionUseCase","31":"GetListLiveSessionUseCase","32":"GetListLiveStreamUseCase","33":"GetLiveChannelUseCase","34":"GetLiveSessionUseCase","35":"GetOrganizationUseCase","36":"GetPlusPromotionUseCase","37":"GetPostContentBlogUseCase","38":"GetPromotionCodeAlertUseCase","39":"GetPromotionUseCase","40":"GetPubnubCredentialsUseCase","41":"GetSessionDataUserUseCase","42":"GetSimpleUserUseCase","43":"GetSoftwaresCourseUseCase","44":"GetUserAlertUseCase","45":"GetVideoProgressListCourseUseCase","46":"GetVideoSpeedUserUseCase","47":"GetVideoVolumeUserUseCase","48":"LogoutUserUseCase","49":"PathToRegexp","50":"RefreshAccessTokenUserUseCase","51":"RemoveAccessTokenUserUseCase","52":"SearchCourseUseCase","53":"SendHeaderTrackingUseCase","54":"SendLiveFeedbackAnswersUseCase","55":"SendPlayerTrackingUseCase","56":"SendTrackingUseCase","57":"SendVideoProgressCourseUseCase","58":"SetAdvanceGDPRStatusUserUseCase","59":"SetGDPRStatusUserUseCase","60":"SetVideoSpeedUserUseCase","61":"SetVideoVolumeUserUseCase","62":"UpdateLanguageUserUseCase","63":"UpdateLiveSessionUseCase","64":"UpdateVideoAudioAndSubtitlesCourseUseCase","65":"UpdateVideoProgressCourseUseCase","66":"ViewPageTrackingUseCase","134":"vendors~AddClosedAlertIDUseCase","135":"vendors~AlgoliaSearch","136":"vendors~AmplitudeJS","137":"vendors~SearchCourseUseCase","138":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"8a9da03044ca663ab18e","1":"1d2bd8936ef4f2cf2bd3","2":"9af03101830d01f690da","3":"7792a0d98c374b514a76","4":"fe884736930ec6122abb","5":"626c92f0bff3f8cc7683","6":"2652f5e418781e021e6a","7":"820439da7239c9daeacd","8":"5a6756a3801556169b05","9":"371f4933acf7001c8f7d","10":"a1a17489bd7a7299081d","11":"55e1f55a7b81db6d656f","12":"28c8d3a60f702373278e","13":"8699aff97f8c1cf3d9df","14":"72f926511b88d5961eb9","15":"460e5aa27ca80d913c3f","16":"bb8c31f1a5e8ef8684d9","17":"ece201bbe18dc0221164","18":"ee36a5b26a91c0b1f957","19":"0b8b5c7834f6b65ff84e","20":"00497089ecf7e965292b","21":"f4728fad48323b87190b","22":"90fdf9eabd33e831d682","23":"69df11f240c115095fff","24":"bcf1bff62f3e6b14af8a","25":"83d2a24b575dd4dc2e99","26":"16d7b1a3b0aa65b29e7c","27":"5568cfb23a7599bafc3e","28":"1d0cfd1906badc353706","29":"7407f799bb1be901407b","30":"29703e4fdff5ca740317","31":"f275f33b3eb7cf25538d","32":"242a08ceffa4303278fe","33":"09ef2df10218b021077a","34":"cdd352f992d61a494559","35":"bfa5b6f567fd2d8c79cc","36":"7b3d1dadd2baa0185064","37":"2306ffb97613f0071323","38":"c5b99248ddb62d0795a9","39":"537de89c2de97fa8fcae","40":"562519dae08c7d2cf15a","41":"33cae4af3d859f7925ce","42":"8e891ae2567bb8e9035d","43":"6ecc4bdc43beaaca271c","44":"71540a3b63842d6c73bb","45":"14a412b4bf8ebe0826f6","46":"2507c08b8a06c55c7f43","47":"025885418589a5777e92","48":"6c4c791912ddbbd20473","49":"104087c49dd8fd83c5ee","50":"df09748a4b9bc33eb029","51":"5a59cd20aa487afe0cf2","52":"224ae8fe85f63b0d9cef","53":"d9ed7f69dce9f650b984","54":"f0ec7c094b3a33944d13","55":"16b62034cd0b97b10446","56":"48a27eb71f8a37b43d0d","57":"b87eeb6ff135399b6a79","58":"6cb03855fcad95342808","59":"c7e6d1979c40272085d1","60":"0fcceefab40f9b5c394b","61":"eb107e4fad6e95692153","62":"fe5b01372aeadd3ba758","63":"2bb1c99a89f6ee456f35","64":"a82fea4e7a010c74b420","65":"9243a77db1694436b092","66":"eb1a11b555ffdd1ca06e","134":"5ee14fe4708262626ced","135":"5dc586cf91723fa22da0","136":"7ed53d2004b48ec4f22a","137":"dce8797ba1395562b572","138":"ec446432953e9b9524ff","201":"4e7a79ca63879b32c016","203":"362444266d233b6ec254","204":"47f4bb19ae4cfccbe115","205":"46d5f2ba467724e5091c"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 341);
